import { useLocation } from "react-router-dom";

import { AppRoutes } from "@/routes";
import { cn } from "@/lib/utils";

// Rotas "full-bleed": telas de mensagem que gerenciam o PRÓPRIO scroll interno
// (o chat interno `/mensagens` e o painel `/atendimentos`). Nelas o <main> do
// shell NÃO deve somar padding nem um segundo `overflow-auto` — senão a página
// (que já tem altura própria + scroll interno) estoura a caixa do <main> e cria
// uma barra de rolagem DUPLA. Match EXATO por pathname (Set, não prefixo): as
// sub-rotas normais (`/atendimentos/nps`, `/atendimentos/templates`, `/voz`,
// `/huddle`, …) são páginas de fluxo comum e mantêm o <main> padrão.
const FULL_BLEED_PATHS = new Set<string>(["/mensagens", "/atendimentos"]);

/**
 * `<main>` do shell autenticado. Full-bleed (sem padding, `overflow-hidden`,
 * `min-h-0`) nas rotas de mensagem; padrão (`overflow-auto` + `p-4 sm:p-6`,
 * idêntico ao histórico) em todas as outras rotas.
 */
export function AppMain() {
  const { pathname } = useLocation();
  const fullBleed = FULL_BLEED_PATHS.has(pathname);
  return (
    <main
      className={cn(
        // SEM cor de fundo própria (Liquid Glass): o `<main>` é transparente pra
        // deixar aparecer as manchas do `.app-canvas` no shell (App.tsx). Um
        // fundo sólido aqui taparia a CAMADA 1 inteira e o efeito sumiria.
        "flex-1",
        fullBleed ? "min-h-0 overflow-hidden" : "overflow-auto p-4 sm:p-6"
      )}
      data-fullbleed={fullBleed ? "true" : "false"}
    >
      <AppRoutes />
    </main>
  );
}

export default AppMain;
